import * as React from "react";

const IconInfoCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#141938"
      d="M9.993 3.13a6.878 6.878 0 0 0-6.876 6.876 6.878 6.878 0 0 0 6.876 6.876 6.878 6.878 0 0 0 6.875-6.876 6.87 6.87 0 0 0-6.875-6.875Zm0 3.12a.93.93 0 0 1 .932.932.938.938 0 0 1-.932.933.93.93 0 0 1-.933-.933c0-.511.421-.933.933-.933Zm1.252 7.5H9.379a.627.627 0 0 1 0-1.252h.307V9.993h-.307a.627.627 0 0 1 0-1.252h.933c.345 0 .626.281.626.626v3.131h.307a.627.627 0 0 1 0 1.253Z"
    />
  </svg>
);
export default IconInfoCircle;
